import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { Spin } from 'antd';
import { memo } from 'react';
import styled from 'styled-components';

import theme from '../../assets/theme';
import useGamePin from '../../hooks/useGamePin';
import { getConfig } from '../../utils/store';
import { zIndexes } from '../../utils/zIndexes';
import { Button } from '../_atoms/Button';

export const PinCodeNudger = memo(
  ({
    gameId,
    onPinClick,
    backgroundBrightness,
  }: {
    gameId?: string;
    onPinClick?: () => void;
    backgroundBrightness?: number | null;
  }) => {
    const url = getConfig().game.url;
    const { t } = useTranslate();

    const { pin: pinCode, isLoading, refetch } = useGamePin(gameId);

    return (
      <UrlAndPinContainer
        onClick={() => onPinClick && onPinClick()}
        $cursor={'pointer'}
        id={'url-and-pin-container'}
      >
        {!!onPinClick && !!pinCode && (
          <UrlHoverModal
            id="url-hover-modal"
            $darkmode={
              backgroundBrightness && backgroundBrightness >= 0.49 ? true : false
            }
          >
            <UrlHoverModalSpan>
              <span style={{ textAlign: 'center' }}>
                {' '}
                <strong>{url.toLowerCase()}</strong>
              </span>
              <UrlHoverModalSpanPin>pin: {pinCode}</UrlHoverModalSpanPin>
              <UrlHoverPinButton
                $darkmode={
                  backgroundBrightness && backgroundBrightness >= 0.49 ? true : false
                }
                type="ghost"
              >
                {t('Open join screen')}
              </UrlHoverPinButton>
            </UrlHoverModalSpan>
          </UrlHoverModal>
        )}
        <span
          style={{
            color:
              backgroundBrightness && backgroundBrightness < 0.5 ? 'white' : undefined,
            background:
              backgroundBrightness && backgroundBrightness < 0.5
                ? theme.colors.black
                : undefined,
            fontSize: 40,
            padding: '0px 30px 0px 30px',
            borderRadius: '0px 0px 10px 10px',
          }}
        >
          {t('Join at')}
          <strong> {url.toLowerCase()} </strong>
          {t('with pin')}: <strong>{pinCode || ''}</strong>
          {!pinCode && isLoading && (
            <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} spin />} />
          )}
          {!pinCode && !isLoading && (
            <ReloadOutlined
              style={{ fontSize: 36, cursor: 'pointer' }}
              onClick={e => {
                e.stopPropagation();
                refetch();
              }}
            />
          )}
        </span>
      </UrlAndPinContainer>
    );
  },
);

PinCodeNudger.displayName = 'PinCodeNudger';
export const UrlHoverModalSpanPin = styled.span`
  font-size: 100px;
`;

export const UrlHoverPinButton = styled(Button)<{ $darkmode: boolean }>`
  border-radius: 10px;

  ${({ $darkmode }) =>
    $darkmode
      ? `
      color: ${theme.colors.white};
      border-color: ${theme.colors.white};
      
      &:hover,
      &:focus {
        color: ${theme.colors.white};
        background-color: ${theme.colors.greyDark};
        border-color: ${theme.colors.white};
      }
    `
      : `
    color: ${theme.colors.black};
    border-color: ${theme.colors.black};
    
    &:hover,
    &:focus {
      color: ${theme.colors.black};
      background-color: ${theme.colors.greyLight};
      border-color: ${theme.colors.black};
    }
    `}
`;

export const UrlHoverModal = styled.div<{ $darkmode: boolean }>`
  position: absolute;
  top: 0;
  transform: translateY(-100%);
  background-color: ${({ $darkmode }) =>
    $darkmode ? theme.colors.black : theme.colors.white};
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  color: ${({ $darkmode }) => ($darkmode ? theme.colors.white : theme.colors.black)};
  display: flex;
  padding: 20px;
  opacity: 0;
  border-radius: 0px 0px 10px 10px;
  transition: 1s;
`;

export const UrlHoverModalSpan = styled.span`
  display: grid;
  width: 100%;
  justify-content: center;
  justify-items: center;
  grid-auto-flow: row;
  font-size: 60px;
`;

const UrlAndPinContainer = styled.div<{ $cursor: string }>`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: ${zIndexes('WYSIWYF_PIN_CODE')};
  border-radius: 0px 0px 10px 10px;
  display: flex;
  cursor: ${({ $cursor }) => $cursor};
  justify-content: center;
  align-items: center;
  opacity: 1;
  background: rgba(255, 255, 255, 0.8);

  color: ${theme.colors.black};
  &:hover #url-hover-modal {
    opacity: 1;
    transform: translateY(0%);
    overflow: visible;
  }
  &:hover {
    opacity: 1;
    overflow: visible;
  }

  @media (max-width: 800px) {
    width: 95%;
  }
`;
